import z from 'zod';
const bonusAnalysisSimilarSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    type_name: z.string(),
    type_value: z.string(),
    attribute_id: z.number().nullable(),
    attribute_name: z.string(),
    ranking: z.number(),
});
const bonusAnalysisParameterSchema = z.object({
    name: z.string(),
    type: z.string(),
    typeValue: z.string(),
    value: z.union([z.boolean(), z.number()]),
    summary: z.string(),
    similars: z.array(bonusAnalysisSimilarSchema).optional(),
});
const bonusAnalysisAmbitoTerritorialeSchema = z.object({
    type: z.string(),
    name: z.string(),
    territorial_id: z.string(),
});
const bonusAnalysisSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    parameters: z.array(z.array(bonusAnalysisParameterSchema)).optional(),
    data_inizio: z.string().optional(),
    data_fine: z.string().optional(),
    links: z.any().nullable().optional(),
    ambito_territoriale: z.array(bonusAnalysisAmbitoTerritorialeSchema).optional(),
});
export { bonusAnalysisSchema };
//# sourceMappingURL=bonusAnalysisSchema.js.map